import LeadsDSPrivate from "./LeadsDSPrivate";

export default LeadsDSPrivate;
